import { render, staticRenderFns } from "./_inputRowFooter.vue?vue&type=template&id=1c42afb5&scoped=true"
import script from "./_inputRowFooter.vue?vue&type=script&lang=js"
export * from "./_inputRowFooter.vue?vue&type=script&lang=js"
import style0 from "./_inputRowFooter.vue?vue&type=style&index=0&id=1c42afb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c42afb5",
  null
  
)

export default component.exports